import { Component } from '@angular/core';
import { environment } from '../environments/environment';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {

    prod = false;
    env;

    constructor() {
        this.env = environment;
        this.prod = environment.production;
    }


}



// WEBPACK FOOTER //
// ./src/app/app.component.ts